// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aside_logo {
    width: 70%;
    height: 50px;
    margin-left: 15%;
    margin-top: 12px;
}
.Aside_logo_div{
    background-color: #063;
}
.commonAside_sider{
    background-color: #063;
}
.ant-menu-item-selected{
    color: #fff !important;
}
.ant-menu-item {
    color: black;
}

.Aside_logo_ele {
    margin-top: 10px;
    border-radius: 50%;
    background-color: #063;
    width: 150px;
    height: 150px;
    position: relative;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.Aside_logo_ele>img {
    width: 120px;
    height: 120px;
    margin-right: 10px;
}

:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark .ant-menu-item,
:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu .ant-menu-item,
:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark .ant-menu-submenu-title,
:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu .ant-menu-submenu-title {
    color: #000;
}

:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover,
:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    color: #000;
}

/* 在你的CSS文件中 */

/* 修改菜单项（Menu.Item）的默认背景色和文本颜色 */
.ant-layout-sider-dark .ant-menu-item-selected {
    background-color: #063;
    /* 你想要的高亮颜色 */
    color: #fff;
    /* 选中项的文本颜色 */
}

/* 如果你想要更多的样式修改，可以继续添加CSS规则 */
.ant-layout-sider-dark .ant-menu-item-selected:hover {
    background-color: #063;
    /* 鼠标悬停时的颜色 */
}`, "",{"version":3,"sources":["webpack://./src/components/commonAside/commonAside.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA,cAAc;;AAEd,gCAAgC;AAChC;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,aAAa;AACjB","sourcesContent":[".Aside_logo {\r\n    width: 70%;\r\n    height: 50px;\r\n    margin-left: 15%;\r\n    margin-top: 12px;\r\n}\r\n.Aside_logo_div{\r\n    background-color: #063;\r\n}\r\n.commonAside_sider{\r\n    background-color: #063;\r\n}\r\n.ant-menu-item-selected{\r\n    color: #fff !important;\r\n}\r\n.ant-menu-item {\r\n    color: black;\r\n}\r\n\r\n.Aside_logo_ele {\r\n    margin-top: 10px;\r\n    border-radius: 50%;\r\n    background-color: #063;\r\n    width: 150px;\r\n    height: 150px;\r\n    position: relative;\r\n    left: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.Aside_logo_ele>img {\r\n    width: 120px;\r\n    height: 120px;\r\n    margin-right: 10px;\r\n}\r\n\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark .ant-menu-item,\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu .ant-menu-item,\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark .ant-menu-submenu-title,\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu .ant-menu-submenu-title {\r\n    color: #000;\r\n}\r\n\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover,\r\n:where(.css-dev-only-do-not-override-qnu6hi).ant-menu-dark>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {\r\n    color: #000;\r\n}\r\n\r\n/* 在你的CSS文件中 */\r\n\r\n/* 修改菜单项（Menu.Item）的默认背景色和文本颜色 */\r\n.ant-layout-sider-dark .ant-menu-item-selected {\r\n    background-color: #063;\r\n    /* 你想要的高亮颜色 */\r\n    color: #fff;\r\n    /* 选中项的文本颜色 */\r\n}\r\n\r\n/* 如果你想要更多的样式修改，可以继续添加CSS规则 */\r\n.ant-layout-sider-dark .ant-menu-item-selected:hover {\r\n    background-color: #063;\r\n    /* 鼠标悬停时的颜色 */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
